module.exports = __webpack_public_path__ + "static/logo-netjets-36f01653876cf29daf1a9c2d6597d218.png";